module.exports = __webpack_public_path__ + "static/img/banner4.9cd94a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner4.jpg
// module id = rJCu
// module chunks = 0